import React, { CSSProperties } from 'react';
import { TblFltOption } from './table.types';

type TblFltInputDropListProps = {
    id: string;
    val: string;
    options?: TblFltOption[];
    onFilter: (val: string) => void;
};

const TableFltInputDropList = ({ id, val, options, onFilter }: TblFltInputDropListProps): JSX.Element => {
    // filter dropdown css tweak
    const fltDroplistStyle: CSSProperties = {
        height: '2em',
        padding: 0,
    };

    return (
        <select
            id={id}
            value={val ?? ''}
            onChange={e => onFilter(e.target.value)}
            style={fltDroplistStyle}
        >
            {options
                ? options.map((opt, idx) => (
                      <option
                          key={idx}
                          value={opt.val}
                      >
                          {opt.lbl}
                      </option>
                  ))
                : null}
        </select>
    );
};

export default TableFltInputDropList;
